export default "__VITE_ASSET__Bh6J9yUn__"